<template>
  <div id="reportList">
    <van-tabs v-model="active">
      <van-tab
        
        title="运营汇总"
      >
        <div v-if="$store.state.buttonAuth.indexOf('crm_report') > -1">
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 房间汇总
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th>当前满租率</th>
                     <th>综合满租率</th>
                    <th>总房间数</th>
                    <th>运营总房间数</th>
                    <th>空置房间数</th>
                    <th>待保洁房间数</th>
                    <th>已入住房间数</th>
                    <th>待签约+签约中</th>
                    <th>待施工+施工中</th>
                    <th>退房中+已退房</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in roomData || []"
                    :key="trx"
                    @click="roomIndex = trx"
                    :class="{ active: roomIndex === trx }"
                  >
                    <td class="min2">{{ tr.companyName }}</td>
                    <td class="min2">{{ tr.fullRate }}</td>
                         <td class="min2">{{ tr.zhRate }}</td>
                    <td class="min2">{{ tr.totalRoomNums }}</td>
                    <td class="min2">{{ tr.operateRoomNums }}</td>
                    <td class="min2">{{ tr.emptyRoomNums }}</td>
                    <td class="min2">{{ tr.cleanRoomNums }}</td>
                    <td class="min2">{{ tr.fullRoomNums }}</td>
                    <td class="min2">{{ tr.waitingRoomNums }}</td>
                    <td class="min2">{{ tr.decorateRoomNums }}</td>
                    <td class="min2">{{ tr.returnRoomNums }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
            <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 多人间汇总
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th>当前满租率</th>
                    <th>总床位数</th>
                    <th>运营总床位数</th>
                    <th>空置床位数</th>
                    <th>待保洁床位数</th>
                    <th>已入住床位数</th>
                    <th>待签约+签约中</th>
                    <th>待施工+施工中</th>
                    <th>退房中+已退房</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in bedsInfoData || []"
                    :key="trx"
                    @click="roomIndex = trx"
                    :class="{ active: roomIndex === trx }"
                  >
                    <td class="min2">{{ tr.companyName }}</td>
                    <td class="min2">{{ tr.fullRate }}</td>
                    <td class="min2">{{ tr.totalRoomNums }}</td>
                    <td class="min2">{{ tr.operateRoomNums }}</td>
                    <td class="min2">{{ tr.emptyRoomNums }}</td>
                    <td class="min2">{{ tr.cleanRoomNums }}</td>
                    <td class="min2">{{ tr.fullRoomNums }}</td>
                    <td class="min2">{{ tr.waitingRoomNums }}</td>
                    <td class="min2">{{ tr.decorateRoomNums }}</td>
                    <td class="min2">{{ tr.returnRoomNums }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 签约汇总
            </div>
            <div class="filter">
              <div class="t1">
                <div
                  class="t"
                  :class="{ clicked: contractActive1 == 1 }"
                  @click="contractActive1 = 1"
                >
                  滚动
                </div>
                <div
                  class="t"
                  :class="{ clicked: contractActive1 == 2 }"
                  @click="contractActive1 = 2"
                >
                  固定
                </div>
                <div
                  class="t"
                  :class="{ clicked: contractActive1 == 3 }"
                  @click="
                    contractActive1 = 3;
                    contractQuery = { startRangeDate: '', endRangeDate: '' };
                  "
                >
                  自定义
                </div>
              </div>
              <div class="t2" v-show="contractActive1 == 1">
                <div
                  class="t"
                  :class="{ clicked: contractActive2 == 1 }"
                  @click="
                    contractActive2 = 1;
                    contractQuery = {
                      startRangeDate: nowDate,
                      endRangeDate: nowDate,
                    };
                    getContract();
                  "
                >
                  当日
                </div>
                <div
                  class="t"
                  :class="{ clicked: contractActive2 == 2 }"
                  @click="
                    contractActive2 = 2;
                    contractQuery = {
                      startRangeDate: nowDate7,
                      endRangeDate: nowDate,
                    };
                    getContract();
                  "
                >
                  近7天
                </div>
                <div
                  class="t"
                  :class="{ clicked: contractActive2 == 3 }"
                  @click="
                    contractActive2 = 3;
                    contractQuery = {
                      startRangeDate: nowDate30,
                      endRangeDate: nowDate,
                    };
                    getContract();
                  "
                >
                  近30天
                </div>
              </div>
              <div class="t2" v-show="contractActive1 == 2">
                <div
                  class="t"
                  :class="{ clicked: contractActive2 == 4 }"
                  @click="
                    contractActive2 = 4;
                    contractQuery = {
                      startRangeDate: startWeekDate,
                      endRangeDate: endWeekDate,
                    };
                    getContract();
                  "
                >
                  上周
                </div>
                <div
                  class="t"
                  :class="{ clicked: contractActive2 == 5 }"
                  @click="
                    contractActive2 = 5;
                    contractQuery = {
                      startRangeDate: startMonthDate,
                      endRangeDate: endMonthDate,
                    };
                    getContract();
                  "
                >
                  上个月
                </div>
              </div>
              <div class="t2" v-show="contractActive1 == 3">
                <van-field
                  readonly
                  clickable
                  :value="
                    contractQuery.startRangeDate
                      ? `${contractQuery.startRangeDate}~${contractQuery.endRangeDate}`
                      : ''
                  "
                  placeholder="请选择时间范围"
                  @click="
                    showDate = true;
                    activeDate = 'contract';
                  "
                />
              </div>
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th>签约总数</th>
                    <th>新签数</th>
                    <th>续约数</th>
                    <th>换房数</th>
                    <th>转租数</th>
                    <th>提交</th>
                    <th>打回</th>
                    <th>审核通过</th>
                    <th style="text-align: right">签约平均单价</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in contractData || []"
                    :key="trx"
                    @click="contractIndex = trx"
                    :class="{ active: contractIndex === trx }"
                  >
                    <td class="min2">{{ tr.companyName }}</td>
                    <td class="min1">{{ tr.totalSignNums }}</td>
                    <td class="min1">{{ tr.newSignNums }}</td>
                    <td class="min1">{{ tr.continueSignNums }}</td>
                    <td class="min1">{{ tr.changeSignNums }}</td>
                    <td class="min1">{{ tr.transferSignNums }}</td>
                    <td class="min1">{{ tr.submitNums }}</td>
                    <td class="min1">{{ tr.modifyNums }}</td>
                    <td class="min1">{{ tr.approvalNums }}</td>
                    <td class="min1" style="text-align: right">
                      {{ tr.averagePrice }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 退租汇总
            </div>
            <div class="filter">
              <div class="t1">
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive1 == 1 }"
                  @click="returnOrderActive1 = 1"
                >
                  滚动
                </div>
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive1 == 2 }"
                  @click="returnOrderActive1 = 2"
                >
                  固定
                </div>
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive1 == 3 }"
                  @click="
                    returnOrderActive1 = 3;
                    returnOrderQuery = { startRangeDate: '', endRangeDate: '' };
                  "
                >
                  自定义
                </div>
              </div>
              <div class="t2" v-show="returnOrderActive1 == 1">
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive2 == 1 }"
                  @click="
                    returnOrderActive2 = 1;
                    returnOrderQuery = {
                      startRangeDate: nowDate,
                      endRangeDate: nowDate,
                    };
                    getReturnOrder();
                  "
                >
                  当日
                </div>
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive2 == 2 }"
                  @click="
                    returnOrderActive2 = 2;
                    returnOrderQuery = {
                      startRangeDate: nowDate7,
                      endRangeDate: nowDate,
                    };
                    getReturnOrder();
                  "
                >
                  近7天
                </div>
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive2 == 3 }"
                  @click="
                    returnOrderActive2 = 3;
                    returnOrderQuery = {
                      startRangeDate: nowDate30,
                      endRangeDate: nowDate,
                    };
                    getReturnOrder();
                  "
                >
                  近30天
                </div>
              </div>
              <div class="t2" v-show="returnOrderActive1 == 2">
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive2 == 4 }"
                  @click="
                    returnOrderActive2 = 4;
                    returnOrderQuery = {
                      startRangeDate: startWeekDate,
                      endRangeDate: endWeekDate,
                    };
                    getReturnOrder();
                  "
                >
                  上周
                </div>
                <div
                  class="t"
                  :class="{ clicked: returnOrderActive2 == 5 }"
                  @click="
                    returnOrderActive2 = 5;
                    returnOrderQuery = {
                      startRangeDate: startMonthDate,
                      endRangeDate: endMonthDate,
                    };
                    getReturnOrder();
                  "
                >
                  上个月
                </div>
              </div>
              <div class="t2" v-show="returnOrderActive1 == 3">
                <van-field
                  readonly
                  clickable
                  :value="
                    returnOrderQuery.startRangeDate
                      ? `${returnOrderQuery.startRangeDate}~${returnOrderQuery.endRangeDate}`
                      : ''
                  "
                  placeholder="请选择时间范围"
                  @click="
                    showDate = true;
                    activeDate = 'returnOrder';
                  "
                />
              </div>
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th>总数</th>
                    <th>到期退租</th>
                    <th>租客违约退</th>
                    <th>正常提前退租</th>
                    <th>公司违约退</th>
                    <th>协商违约退</th>
                    <th>续约退租</th>
                    <th>换房退租</th>
                    <th>转租退租</th>
                    <th>预计30天到期数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in returnOrderData || []"
                    :key="trx"
                    @click="returnOrderIndex = trx"
                    :class="{ active: returnOrderIndex === trx }"
                  >
                    <td class="min2">{{ tr.companyName }}</td>
                    <td class="min1">{{ tr.totalNums }}</td>
                    <td class="min1">{{ tr.normalNums }}</td>
                    <td class="min1">{{ tr.advanceNums }}</td>
                    <td class="min1">{{ tr.normalAdvanceNums }}</td>
                    <td class="min1">{{ tr.companyDefaultNums }}</td>
                    <td class="min1">{{ tr.negotiateDefaultNums }}</td>
                    <td class="min1">{{ tr.renewalNums }}</td>
                    <td class="min1">{{ tr.changeNums }}</td>
                    <td class="min1">{{ tr.subletNums }}</td>
                    <td class="min1">{{ tr.expireNums }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 财务汇总
            </div>
            <div class="filter">
              <div class="t1">
                <div
                  class="t"
                  :class="{ clicked: financialActive1 == 1 }"
                  @click="financialActive1 = 1"
                >
                  滚动
                </div>
                <div
                  class="t"
                  :class="{ clicked: financialActive1 == 2 }"
                  @click="financialActive1 = 2"
                >
                  固定
                </div>
                <div
                  class="t"
                  :class="{ clicked: financialActive1 == 3 }"
                  @click="
                    financialActive1 = 3;
                    financialQuery = { startRangeDate: '', endRangeDate: '' };
                  "
                >
                  自定义
                </div>
              </div>
              <div class="t2" v-show="financialActive1 == 1">
                <div
                  class="t"
                  :class="{ clicked: financialActive2 == 1 }"
                  @click="
                    financialActive2 = 1;
                    financialQuery = {
                      startRangeDate: nowDate,
                      endRangeDate: nowDate,
                    };
                    getFinancial();
                  "
                >
                  当日
                </div>
                <div
                  class="t"
                  :class="{ clicked: financialActive2 == 2 }"
                  @click="
                    financialActive2 = 2;
                    financialQuery = {
                      startRangeDate: nowDate7,
                      endRangeDate: nowDate,
                    };
                    getFinancial();
                  "
                >
                  近7天
                </div>
                <div
                  class="t"
                  :class="{ clicked: financialActive2 == 3 }"
                  @click="
                    financialActive2 = 3;
                    financialQuery = {
                      startRangeDate: nowDate30,
                      endRangeDate: nowDate,
                    };
                    getFinancial();
                  "
                >
                  近30天
                </div>
              </div>
              <div class="t2" v-show="financialActive1 == 2">
                <div
                  class="t"
                  :class="{ clicked: financialActive2 == 4 }"
                  @click="
                    financialActive2 = 4;
                    financialQuery = {
                      startRangeDate: startWeekDate,
                      endRangeDate: endWeekDate,
                    };
                    getFinancial();
                  "
                >
                  上周
                </div>
                <div
                  class="t"
                  :class="{ clicked: financialActive2 == 5 }"
                  @click="
                    financialActive2 = 5;
                    financialQuery = {
                      startRangeDate: startMonthDate,
                      endRangeDate: endMonthDate,
                    };
                    getFinancial();
                  "
                >
                  上个月
                </div>
              </div>
              <div class="t2" v-show="financialActive1 == 3">
                <van-field
                  readonly
                  clickable
                  :value="
                    financialQuery.startRangeDate
                      ? `${financialQuery.startRangeDate}~${financialQuery.endRangeDate}`
                      : ''
                  "
                  placeholder="请选择时间范围"
                  @click="
                    showDate = true;
                    activeDate = 'financial';
                  "
                />
              </div>
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th style="text-align: right">收入</th>
                    <th style="text-align: right">实收</th>
                    <th style="text-align: right">欠款</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in financialData || []"
                    :key="trx"
                    @click="financialIndex = trx"
                    :class="{ active: financialIndex === trx }"
                  >
                    <td class="min2">{{ tr.companyName }}</td>
                    <td class="min2" style="text-align: right">
                      {{ tr.financialIncome }}
                    </td>
                    <td class="min2" style="text-align: right">
                      {{ tr.income }}
                    </td>
                    <td class="min2" style="text-align: right">
                      {{ tr.arrears }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 工单汇总
            </div>
            <div class="filter">
              <div class="t1">
                <div
                  class="t"
                  :class="{ clicked: workOrderActive1 == 1 }"
                  @click="workOrderActive1 = 1"
                >
                  滚动
                </div>
                <div
                  class="t"
                  :class="{ clicked: workOrderActive1 == 2 }"
                  @click="workOrderActive1 = 2"
                >
                  固定
                </div>
                <div
                  class="t"
                  :class="{ clicked: workOrderActive1 == 3 }"
                  @click="
                    workOrderActive1 = 3;
                    workOrderQuery = { startRangeDate: '', endRangeDate: '' };
                  "
                >
                  自定义
                </div>
              </div>
              <div class="t2" v-show="workOrderActive1 == 1">
                <div
                  class="t"
                  :class="{ clicked: workOrderActive2 == 1 }"
                  @click="
                    workOrderActive2 = 1;
                    workOrderQuery = {
                      startRangeDate: nowDate,
                      endRangeDate: nowDate,
                    };
                    getWorkOrder();
                  "
                >
                  当日
                </div>
                <div
                  class="t"
                  :class="{ clicked: workOrderActive2 == 2 }"
                  @click="
                    workOrderActive2 = 2;
                    workOrderQuery = {
                      startRangeDate: nowDate7,
                      endRangeDate: nowDate,
                    };
                    getWorkOrder();
                  "
                >
                  近7天
                </div>
                <div
                  class="t"
                  :class="{ clicked: workOrderActive2 == 3 }"
                  @click="
                    workOrderActive2 = 3;
                    workOrderQuery = {
                      startRangeDate: nowDate30,
                      endRangeDate: nowDate,
                    };
                    getWorkOrder();
                  "
                >
                  近30天
                </div>
              </div>
              <div class="t2" v-show="workOrderActive1 == 2">
                <div
                  class="t"
                  :class="{ clicked: workOrderActive2 == 4 }"
                  @click="
                    workOrderActive2 = 4;
                    workOrderQuery = {
                      startRangeDate: startWeekDate,
                      endRangeDate: endWeekDate,
                    };
                    getWorkOrder();
                  "
                >
                  上周
                </div>
                <div
                  class="t"
                  :class="{ clicked: workOrderActive2 == 5 }"
                  @click="
                    workOrderActive2 = 5;
                    workOrderQuery = {
                      startRangeDate: startMonthDate,
                      endRangeDate: endMonthDate,
                    };
                    getWorkOrder();
                  "
                >
                  上个月
                </div>
              </div>
              <div class="t2" v-show="workOrderActive1 == 3">
                <van-field
                  readonly
                  clickable
                  :value="
                    workOrderQuery.startRangeDate
                      ? `${workOrderQuery.startRangeDate}~${workOrderQuery.endRangeDate}`
                      : ''
                  "
                  placeholder="请选择时间范围"
                  @click="
                    showDate = true;
                    activeDate = 'workOrder';
                  "
                />
              </div>
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>公司名称</th>
                    <th>执行中工单总数</th>
                    <th>投诉工单</th>
                    <th>维修工单</th>
                    <th>保洁工单</th>
                    <th>其他工单（咨询+清洗+搬运）</th>
                    <th>处理超时数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in workOrderData || []"
                    :key="trx"
                    @click="workOrderIndex = trx"
                    :class="{ active: workOrderIndex === trx }"
                  >
                    <td class="min2">{{ tr.companyName }}</td>
                    <td class="min2">{{ tr.handingNums }}</td>
                    <td class="min15">{{ tr.tsNums }}</td>
                    <td class="min15">{{ tr.wxNums }}</td>
                    <td class="min15">{{ tr.bjNums }}</td>
                    <td class="min3">{{ tr.otherNums }}</td>
                    <td class="min15">{{ tr.timeOutNums }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 跟进记录
            </div>
            <div class="filter">
              <div class="t1">
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive1 == 1 }"
                  @click="trackRecordActive1 = 1"
                >
                  滚动
                </div>
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive1 == 2 }"
                  @click="trackRecordActive1 = 2"
                >
                  固定
                </div>
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive1 == 3 }"
                  @click="
                    trackRecordActive1 = 3;
                    trackRecordQuery = { startRangeDate: '', endRangeDate: '' };
                  "
                >
                  自定义
                </div>
              </div>
              <div class="t2" v-show="trackRecordActive1 == 1">
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive2 == 1 }"
                  @click="
                    trackRecordActive2 = 1;
                    trackRecordQuery = {
                      startRangeDate: nowDate,
                      endRangeDate: nowDate,
                    };
                    getTrackRecord();
                  "
                >
                  当日
                </div>
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive2 == 2 }"
                  @click="
                    trackRecordActive2 = 2;
                    trackRecordQuery = {
                      startRangeDate: nowDate7,
                      endRangeDate: nowDate,
                    };
                    getTrackRecord();
                  "
                >
                  近7天
                </div>
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive2 == 3 }"
                  @click="
                    trackRecordActive2 = 3;
                    trackRecordQuery = {
                      startRangeDate: nowDate30,
                      endRangeDate: nowDate,
                    };
                    getTrackRecord();
                  "
                >
                  近30天
                </div>
              </div>
              <div class="t2" v-show="trackRecordActive1 == 2">
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive2 == 4 }"
                  @click="
                    trackRecordActive2 = 4;
                    trackRecordQuery = {
                      startRangeDate: startWeekDate,
                      endRangeDate: endWeekDate,
                    };
                    getTrackRecord();
                  "
                >
                  上周
                </div>
                <div
                  class="t"
                  :class="{ clicked: trackRecordActive2 == 5 }"
                  @click="
                    trackRecordActive2 = 5;
                    trackRecordQuery = {
                      startRangeDate: startMonthDate,
                      endRangeDate: endMonthDate,
                    };
                    getTrackRecord();
                  "
                >
                  上个月
                </div>
              </div>
              <div class="t2" v-show="trackRecordActive1 == 3">
                <van-field
                  readonly
                  clickable
                  :value="
                    trackRecordQuery.startRangeDate
                      ? `${trackRecordQuery.startRangeDate}~${trackRecordQuery.endRangeDate}`
                      : ''
                  "
                  placeholder="请选择时间范围"
                  @click="
                    showDate = true;
                    activeDate = 'trackRecord';
                  "
                />
              </div>
            </div>
            <div class="body">
              <table>
                <thead>
                  <tr>
                    <th>全部</th>
                    <th>电话咨询</th>
                    <th>在线咨询</th>
                    <th>预约带看</th>
                    <th>完成带看</th>
                    <th>完成签约</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, trx) in trackRecordData || []"
                    :key="trx"
                    @click="trackRecordIndex = trx"
                    :class="{ active: trackRecordIndex === trx }"
                  >
                    <td style="text-align: center">{{ tr.totalNums }}</td>
                    <td>{{ tr.phoneConsultNums }}</td>
                    <td>{{ tr.onlineConsultNums }}</td>
                    <td>{{ tr.appointNums }}</td>
                    <td>{{ tr.finishAppointNums }}</td>
                    <td>{{ tr.finishSignNums }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 满租率统计
            </div>
            <div class="filter">
              <van-field
                readonly
                clickable
                :value="
                  rateQuery.startRangeDate
                    ? `${rateQuery.startRangeDate}~${rateQuery.endRangeDate}`
                    : ''
                "
                placeholder="请选择时间范围"
                @click="
                  maxDate = new Date(
                    new Date().getTime() - 24 * 60 * 60 * 1000
                  );
                  showDate = true;
                  activeDate = 'rate';
                "
              />
            </div>
            <div style="overflow-x: auto">
              <div class="chart" id="chartRate"></div>
            </div>
          </div>
          <div class="line"></div>
          <div class="card">
            <div class="title">
              <i class="iconfont iconbookmark"></i> 平均出租价格统计
            </div>
            <div style="overflow-x: auto">
              <div class="chart" id="chartAverage"></div>
            </div>
          </div>
          <div class="space"></div>
        </div>
         <van-empty v-else description="暂无数据" />
      </van-tab>
      <van-tab title="跟踪记录汇总">
        <div
          class="card"
          v-if="$store.state.buttonAuth.indexOf('crm_trackRecordAll') > -1"
        >
          <div class="title">
            <i class="iconfont iconbookmark"></i> 跟踪记录汇总
          </div>
          <div class="filter">
            <div class="t1">
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive1 == 1 }"
                @click="trackRecordAllActive1 = 1"
              >
                滚动
              </div>
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive1 == 2 }"
                @click="trackRecordAllActive1 = 2"
              >
                固定
              </div>
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive1 == 3 }"
                @click="
                  trackRecordAllActive1 = 3;
                  trackRecordAllQuery = {
                    startRangeDate: '',
                    endRangeDate: '',
                    companyId: trackRecordAllQuery.companyId,
                  };
                "
              >
                自定义
              </div>
            </div>
            <div class="t2" v-show="trackRecordAllActive1 == 1">
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive2 == 1 }"
                @click="
                  trackRecordAllActive2 = 1;
                  trackRecordAllQuery = {
                    startRangeDate: nowDate,
                    endRangeDate: nowDate,
                    companyId: trackRecordAllQuery.companyId,
                  };
                  getTrackRecordAll();
                "
              >
                当日
              </div>
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive2 == 2 }"
                @click="
                  trackRecordAllActive2 = 2;
                  trackRecordAllQuery = {
                    startRangeDate: nowDate7,
                    endRangeDate: nowDate,
                    companyId: trackRecordAllQuery.companyId,
                  };
                  getTrackRecordAll();
                "
              >
                近7天
              </div>
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive2 == 3 }"
                @click="
                  trackRecordAllActive2 = 3;
                  trackRecordAllQuery = {
                    startRangeDate: nowDate30,
                    endRangeDate: nowDate,
                    companyId: trackRecordAllQuery.companyId,
                  };
                  getTrackRecordAll();
                "
              >
                近30天
              </div>
            </div>
            <div class="t2" v-show="trackRecordAllActive1 == 2">
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive2 == 4 }"
                @click="
                  trackRecordAllActive2 = 4;
                  trackRecordAllQuery = {
                    startRangeDate: startWeekDate,
                    endRangeDate: endWeekDate,
                    companyId: trackRecordAllQuery.companyId,
                  };
                  getTrackRecordAll();
                "
              >
                上周
              </div>
              <div
                class="t"
                :class="{ clicked: trackRecordAllActive2 == 5 }"
                @click="
                  trackRecordAllActive2 = 5;
                  trackRecordAllQuery = {
                    startRangeDate: startMonthDate,
                    endRangeDate: endMonthDate,
                    companyId: trackRecordAllQuery.companyId,
                  };
                  getTrackRecordAll();
                "
              >
                上个月
              </div>
            </div>
            <div class="t2" v-show="trackRecordAllActive1 == 3">
              <van-field
                readonly
                clickable
                label="时间范围"
                :value="
                  trackRecordAllQuery.startRangeDate
                    ? `${trackRecordAllQuery.startRangeDate}~${trackRecordAllQuery.endRangeDate}`
                    : ''
                "
                placeholder="请选择时间范围"
                @click="
                  showDate = true;
                  activeDate = 'trackRecordAll';
                "
              />
            </div>
            <van-field
              label="当前公司"
              readonly
              clickable
              :value="trackRecordAllCompanyName"
              placeholder="请选择公司查询"
              @click="showPicker = true"
            />
          </div>

          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              value-key="simpleName"
              :columns="companyList"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <div class="body">
            <table>
              <thead>
                <tr>
                  <th>管家姓名</th>
                   <th>新增客户</th>
                  <th>咨询数量</th>
                  <th>预约带看</th>
                  <th>完成带看</th>
                  <th>无意向</th>
                  <th>新签</th>
                  <!-- <th @click="sortTractList('addNums')" >新增客户<van-icon  size="10"  name="arrow-down" /></th>
                  <th @click="sortTractList('askNums')">咨询数量<van-icon  size="10" name="arrow-down" /></th>
                  <th @click="sortTractList('bookNums')">预约带看<van-icon  size="10" name="arrow-down" /></th>
                  <th @click="sortTractList('lookNums')">完成带看<van-icon  size="10" name="arrow-down" /></th>
                  <th @click="sortTractList('nillNums')">无意向<van-icon  size="10" name="arrow-down" /></th>
                  <th @click="sortTractList('signNums')">新签<van-icon  size="10" name="arrow-down" /></th>
                  <th @click="sortTractList('fxqyNums')">分销签约<van-icon  size="10" name="arrow-down" /></th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tr, trx) in trackRecordAllData || []"
                  :key="trx"
                  @click="trackRecordAllIndex = trx"
                  :class="{ active: trackRecordAllIndex === trx }"
                >
                  <td class="min2">{{ tr.ownerName }}</td>
                  <td class="min1">{{ tr.addNums }}</td>
                  <td class="min1">{{ tr.askNums }}</td>
                  <td class="min1">{{ tr.bookNums }}</td>
                  <td class="min1">{{ tr.lookNums }}</td>
                  <td class="min1">{{ tr.nillNums }}</td>
                  <td class="min1">{{ tr.signNums }}</td>
                    <!-- <td class="min1">{{ tr.fxqyNums }}</td> -->
                  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
         <van-empty v-else description="暂无数据" />
      </van-tab>
    </van-tabs>
    <van-calendar
      ref="calendar"
      v-model="showDate"
      type="range"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="searchDateChange"
      @closed="
        $refs.calendar.reset();
        maxDate = new Date(2030, 0, 31);
      "
    />
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapState, mapActions } from "vuex";
import {
  getEndDate,
  formatDate,
  getNdaysDate,
  formatNumberRgx,
  accAdd,
} from "@/utils/index";
import {
  requestReportRoom,
  requestReportContract,
  requestReportReturnOrder,
  requestReportFinancial,
  requestReportWorkOrder,
  requestReportTrackRecord,
  requestReportRate,
  requestReportAveragePrice,
  requestTraceRecord,
  requestReportTrackRecordAll,
} from "@/api";
export default {
  name: "reportList",
  data() {
    return {
      active: 0,
      showDate: false,
      activeDate: "",
      minDate: new Date(2015, 0, 1),
      maxDate: new Date(2030, 0, 31),
      //   跟踪记录汇总
      showPicker: false,
      companyList: [],
      // traceRecordData:[],
      trackRecordAllSearchDate: "",
      trackRecordAllActive1: 1,
      trackRecordAllActive2: 1,
      trackRecordAllCompanyName: "",
      trackRecordAllQuery: {
        startRangeDate: "",
        endRangeDate: "",
        companyId: "",
      },
      trackRecordAllIndex: "",
      trackRecordAllData: [],
      trackRecordAllLoad: true,
      //房间
      roomQuery: {},
      roomData: [],
      roomIndex: "",
      roomLoad: true,
      //合约
      contractSearchDate: "",
      contractActive1: 1,
      contractActive2: 1,
      contractQuery: {
        startRangeDate: "",
        endRangeDate: "",
      },
      contractIndex: "",
      contractData: [],
      contractLoad: true,
      //退租单
      returnOrderSearchDate: "",
      returnOrderActive1: 1,
      returnOrderActive2: 1,
      returnOrderQuery: {
        startRangeDate: "",
        endRangeDate: "",
      },
      returnOrderIndex: "",
      returnOrderData: [],
      returnOrderLoad: true,
      //财务
      financialSearchDate: "",
      financialActive1: 1,
      financialActive2: 1,
      financialQuery: {
        startRangeDate: "",
        endRangeDate: "",
      },
      financialIndex: "",
      financialData: [],
      financialLoad: true,
      //工单
      workOrderSearchDate: "",
      workOrderActive1: 1,
      workOrderActive2: 1,
      workOrderQuery: {
        startRangeDate: "",
        endRangeDate: "",
      },
      workOrderIndex: "",
      workOrderData: [],
      workOrderLoad: true,
      //跟进记录
      trackRecordSearchDate: "",
      trackRecordActive1: 1,
      trackRecordActive2: 1,
      trackRecordQuery: {
        startRangeDate: "",
        endRangeDate: "",
      },
      trackRecordIndex: "",
      trackRecordData: [],
      trackRecordLoad: true,
      //
      rateSearchDate: "",
      rateQuery: {
        startRangeDate: "",
        endRangeDate: "",
      },
      bedsInfoData:"",
      chartRate: "",
      chartAverage: "",
      //时间参数
      nowDate: "", //当天
      nowDate7: "", //近7天
      nowDate30: "", //近30天
      startWeekDate: "", //上周一
      endWeekDate: "", //上周末
      startMonthDate: "", //上月一
      endMonthDate: "", //上月末
    };
  },
  computed: {
    ...mapState([]),
  },
  created() {},
  mounted() {
    this.getRoom();
    this.getContract();
    this.getReturnOrder();
    this.getFinancial();
    this.getWorkOrder();
    this.getTrackRecord();
    this.initDate();
    // console.log(echarts);

    this.getReportRate();
    this.getReportAveragePrice();
    this.getCompanyList();
    this.getTrackRecordAll();
    this.$nextTick(() => {
      this.chartRate = echarts.init(document.getElementById("chartRate"));
      this.chartAverage = echarts.init(document.getElementById("chartAverage"));
    });
  },
  methods: {
    initDate() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth();
      this.nowDate = formatDate(now);
      this.nowDate7 = getNdaysDate(this.nowDate, -6);
      this.nowDate30 = getNdaysDate(this.nowDate, -29);
      this.startWeekDate = getNdaysDate(this.nowDate, -(now.getDay() + 6));
      this.endWeekDate = getNdaysDate(this.nowDate, -now.getDay());
      this.startMonthDate = formatDate(new Date(year, month - 1, 1));
      this.endMonthDate = formatDate(new Date(year, month, 0));
      this.trackRecordAllQuery.startRangeDate = this.nowDate;
      this.trackRecordAllQuery.endRangeDate = this.nowDate;
      this.contractQuery.startRangeDate = this.nowDate;
      this.contractQuery.endRangeDate = this.nowDate;
      this.returnOrderQuery.startRangeDate = this.nowDate;
      this.returnOrderQuery.endRangeDate = this.nowDate;
      this.financialQuery.startRangeDate = this.nowDate;
      this.financialQuery.endRangeDate = this.nowDate;
      this.workOrderQuery.startRangeDate = this.nowDate;
      this.workOrderQuery.endRangeDate = this.nowDate;
      this.trackRecordQuery.startRangeDate = this.nowDate;
      this.trackRecordQuery.endRangeDate = this.nowDate;
    },
    clear() {
      console.log("dasdsa");
    },
    onConfirm(item) {
      console.log(item);
      this.trackRecordAllQuery.companyId = item.id;
      this.trackRecordAllCompanyName = item.simpleName;
      this.showPicker = false;
      this.getTrackRecordAll();
    },
    searchDateChange(e) {
      switch (this.activeDate) {
        case "trackRecordAll":
          this.trackRecordAllQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.trackRecordAllQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.trackRecordAllActive2 = 6;
          this.getTrackRecordAll();
          break;
        case "contract":
          this.contractQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.contractQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.contractActive2 = 6;
          this.getContract();
          break;
        case "returnOrder":
          this.returnOrderQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.returnOrderQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.returnOrderActive2 = 6;
          this.getReturnOrder();
          break;
        case "financial":
          this.financialQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.financialQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.financialActive2 = 6;
          this.getFinancial();
          break;
        case "workOrder":
          this.workOrderQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.workOrderQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.workOrderActive2 = 6;
          this.getWorkOrder();
          break;
        case "trackRecord":
          this.trackRecordQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.trackRecordQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.trackRecordActive2 = 6;
          this.getTrackRecord();
          break;
        case "rate":
          this.rateQuery.startRangeDate = e ? formatDate(e[0]) : "";
          this.rateQuery.endRangeDate = e ? formatDate(e[1]) : "";
          this.getReportRate();
          break;
        default:
          break;
      }

      this.showDate = false;
    },
    getCompanyList() {
      requestTraceRecord().then((res) => {
        console.log(res);
        res.data.unshift({
          simpleName: "全部",
          id: "",
        });
        this.companyList = res.data;
      });
    },
    // 跟踪记录汇总
    getTrackRecordAll() {
      this.trackRecordAllLoad = true;
      requestReportTrackRecordAll(this.trackRecordAllQuery)
        .then((res) => {
          console.log(res);
          this.trackRecordAllLoad = false;
          this.trackRecordAllData = res.data;
        })
        .catch((err) => {
          this.trackRecordAllLoad = false;
          console.log(err);
        });
    },
    //房间
    getRoom() {
      this.roomLoad = true;
      requestReportRoom(this.roomQuery)
        .then((res) => {
          this.roomLoad = false;
          let totalObj = this.getTotal(res.data.roomsInfo);
          totalObj.fullRate = "-";
           totalObj.zhRate = "-";
          totalObj.companyName = "合计";
          res.data.roomsInfo.forEach((d) => {
            d.fullRate = d.fullRate + "%";
            d.zhRate = d.zhRate?d.zhRate+'%':'-';
            d.totalRoomNums = formatNumberRgx(d.totalRoomNums);
            d.operateRoomNums = formatNumberRgx(d.operateRoomNums);
            d.emptyRoomNums = formatNumberRgx(d.emptyRoomNums);
            d.cleanRoomNums = formatNumberRgx(d.cleanRoomNums);
            d.fullRoomNums = formatNumberRgx(d.fullRoomNums);
            d.waitingRoomNums = formatNumberRgx(d.waitingRoomNums);
            d.decorateRoomNums = formatNumberRgx(d.decorateRoomNums);
            d.returnRoomNums = formatNumberRgx(d.returnRoomNums);
          });
          res.data.roomsInfo.push(totalObj);
          this.roomData = res.data.roomsInfo;

          
    let totalObj1 = this.getTotal(res.data.bedsInfo);
          totalObj1.fullRate = "-";
          totalObj1.companyName = "合计";
          res.data.bedsInfo.forEach((d) => {
          d.fullRate = d.fullRate + "%";
         
            d.totalRoomNums = formatNumberRgx(d.totalRoomNums);
            d.operateRoomNums = formatNumberRgx(d.operateRoomNums);
            d.emptyRoomNums = formatNumberRgx(d.emptyRoomNums);
            d.cleanRoomNums = formatNumberRgx(d.cleanRoomNums);
            d.fullRoomNums = formatNumberRgx(d.fullRoomNums);
            d.waitingRoomNums = formatNumberRgx(d.waitingRoomNums);
            d.decorateRoomNums = formatNumberRgx(d.decorateRoomNums);
            d.returnRoomNums = formatNumberRgx(d.returnRoomNums);
          });
          res.data.bedsInfo.push(totalObj1);
          this.bedsInfoData = res.data.bedsInfo || [];
        })
        .catch((err) => {
          this.roomLoad = false;
          console.log(err);
        });
    },
    //合约
    getContract() {
      this.contractLoad = true;
      requestReportContract(this.contractQuery)
        .then((res) => {
          this.contractLoad = false;
          let totalObj = this.getTotal(res.data);
          totalObj.companyName = "合计";
          res.data.forEach((d) => {
            d.totalSignNums = formatNumberRgx(d.totalSignNums);
            d.newSignNums = formatNumberRgx(d.newSignNums);
            d.continueSignNums = formatNumberRgx(d.continueSignNums);
            d.changeSignNums = formatNumberRgx(d.changeSignNums);
            d.transferSignNums = formatNumberRgx(d.transferSignNums);
            d.submitNums = formatNumberRgx(d.submitNums);
            d.modifyNums = formatNumberRgx(d.modifyNums);
            d.approvalNums = formatNumberRgx(d.approvalNums);
            d.averagePrice = d.averagePrice.toFixed(2);
            d.averagePrice = formatNumberRgx(d.averagePrice);
          });
          res.data.push(totalObj);
          this.contractData = res.data;
        })
        .catch((err) => {
          this.contractLoad = false;
          console.log(err);
        });
    },

    //退租单
    getReturnOrder() {
      this.returnOrderLoad = true;
      requestReportReturnOrder(this.returnOrderQuery)
        .then((res) => {
          this.returnOrderLoad = false;
          let totalObj = this.getTotal(res.data);
          totalObj.companyName = "合计";
          res.data.forEach((d) => {
            d.expireNums = formatNumberRgx(d.expireNums);
            d.totalNums = formatNumberRgx(d.totalNums);
            d.normalNums = formatNumberRgx(d.normalNums);
            d.advanceNums = formatNumberRgx(d.advanceNums);
            d.normalAdvanceNums = formatNumberRgx(d.normalAdvanceNums);
            d.companyDefaultNums = formatNumberRgx(d.companyDefaultNums);
            d.propertyDefaultNums = formatNumberRgx(d.propertyDefaultNums);
            d.negotiateDefaultNums = formatNumberRgx(d.negotiateDefaultNums);
            d.renewalNums = formatNumberRgx(d.renewalNums);
            d.changeNums = formatNumberRgx(d.changeNums);
            d.subletNums = formatNumberRgx(d.subletNums);
          });
          res.data.push(totalObj);
          this.returnOrderData = res.data;
        })
        .catch((err) => {
          this.returnOrderLoad = false;
          console.log(err);
        });
    },
    //财务
    getFinancial() {
      this.financialLoad = true;
      requestReportFinancial(this.financialQuery)
        .then((res) => {
          this.financialLoad = false;
          let totalObj = this.getTotal(res.data);
          totalObj.companyName = "合计";
          res.data.forEach((d) => {
            d.arrears = d.arrears.toFixed(2);
            d.financialIncome = d.financialIncome.toFixed(2);
            d.income = d.income.toFixed(2);
            d.arrears = formatNumberRgx(d.arrears);
            d.financialIncome = formatNumberRgx(d.financialIncome);
            d.income = formatNumberRgx(d.income);
          });
          res.data.push(totalObj);
          this.financialData = res.data;
        })
        .catch((err) => {
          this.financialLoad = false;
          console.log(err);
        });
    },
    //工单
    getWorkOrder() {
      this.workOrderLoad = true;
      requestReportWorkOrder(this.workOrderQuery)
        .then((res) => {
          this.workOrderLoad = false;
          let totalObj = this.getTotal(res.data);
          totalObj.companyName = "合计";
          res.data.forEach((d) => {
            d.handingNums = formatNumberRgx(d.handingNums);
            d.tsNums = formatNumberRgx(d.tsNums);
            d.wxNums = formatNumberRgx(d.wxNums);
            d.bjNums = formatNumberRgx(d.bjNums);
            d.otherNums = formatNumberRgx(d.otherNums);
            d.timeOutNums = formatNumberRgx(d.timeOutNums);
          });
          res.data.push(totalObj);
          this.workOrderData = res.data;
        })
        .catch((err) => {
          this.workOrderLoad = false;
          console.log(err);
        });
    },
    //跟进记录
    getTrackRecord() {
      this.trackRecordLoad = true;
      requestReportTrackRecord(this.trackRecordQuery)
        .then((res) => {
          this.trackRecordLoad = false;
          res.data.totalNums = formatNumberRgx(res.data.totalNums);
          res.data.phoneConsultNums = formatNumberRgx(
            res.data.phoneConsultNums
          );
          res.data.onlineConsultNums = formatNumberRgx(
            res.data.onlineConsultNums
          );
          res.data.appointNums = formatNumberRgx(res.data.appointNums);
          res.data.finishAppointNums = formatNumberRgx(
            res.data.finishAppointNums
          );
          res.data.finishSignNums = formatNumberRgx(res.data.finishSignNums);
          this.trackRecordData = [res.data];
        })
        .catch((err) => {
          this.trackRecordLoad = false;
          console.log(err);
        });
    },
    //满租率统计
    getReportRate() {
      requestReportRate(this.rateQuery).then((res) => {
        let companyName = [],
          bizDateList = [],
          seriesList = [],
          length = 0,
          index = 0;
        //取出数据量最多公司
        res.data.forEach((d, i) => {
          companyName.push(d.companyName);
          if (d.fullOccupancyRateList.length > length) {
            length = d.fullOccupancyRateList.length;
            index = i;
          }
        });
        res.data[index].fullOccupancyRateList.forEach((e) => {
          bizDateList.push(e.bizDate);
        });
        res.data.forEach((d) => {
          let fullRateList = [];
          //补全其他公司满租率赋值null
          let fullOccupancyRateListLength = d.fullOccupancyRateList.length;
          for (let i = 0; i < length - fullOccupancyRateListLength; i++) {
            d.fullOccupancyRateList.unshift({
              fullRate: null,
              bizDate: bizDateList[i],
            });
          }
          d.fullOccupancyRateList.forEach((e) => {
            fullRateList.push(e.fullRate);
          });
          seriesList.push({
            name: d.companyName,
            type: "line",
            showSymbol: true,
            smooth: true,
            // label: { show: true, formatter: "{c}%" },
            data: fullRateList,
          });
        });
        this.chartRate.setOption({
          title: {
            text: "满租率",
            x: "center",
            textStyle: {
              color: "#000",
              fontSize: 16,
            },
          },
          tooltip: {
            trigger: "axis",
            // formatter: function (params) {
            //     let str = "";
            //     params.forEach((item, idx) => {
            //         str += `${item.marker}${item.seriesName}: ${item.data}%`;
            //         str += idx === params.length - 1 ? "" : "<br/>";
            //     });
            //     return str;
            // },
          },
          legend: {
            type: "plain",
            bottom: 0,
            itemHeight: 2,
            icon: "rect",
            data: companyName,
          },
          grid: {
            left: "5%",
            right: "5%",
            bottom: "35%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: bizDateList,
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}%",
            },
          },
          series: seriesList,
        });
      });
    },
    //平均出租价格统计
    getReportAveragePrice() {
      requestReportAveragePrice().then((res) => {
        let companyName = [],
          bizDateList = [],
          seriesList = [],
          length = 0,
          index = 0;
        //取出数据量最多公司
        res.data.forEach((d, i) => {
          companyName.push(d.companyName);
          if (d.averagePriceList.length > length) {
            length = d.averagePriceList.length;
            index = i;
          }
        });
        res.data[index].averagePriceList.forEach((e) => {
          bizDateList.push(e.bizDate);
        });
        res.data.forEach((d) => {
          let averageList = [];
          //补全其他公司满租率赋值null
          let fullOccupancyRateListLength = d.averagePriceList.length;
          for (let i = 0; i < length - fullOccupancyRateListLength; i++) {
            d.averagePriceList.unshift({
              averagePrice: null,
              bizDate: bizDateList[i],
            });
          }
          d.averagePriceList.forEach((e) => {
            averageList.push(e.averagePrice);
          });
          seriesList.push({
            name: d.companyName,
            type: "line",
            showSymbol: true,
            smooth: true,
            label: { show: true },
            data: averageList,
          });
        });
        this.chartAverage.setOption({
          title: {
            text: "平均出租价格",
            x: "center",
            textStyle: {
              color: "#000",
              fontSize: 16,
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            type: "plain",
            bottom: 0,
            itemHeight: 2,
            icon: "rect",
            data: companyName,
          },
          grid: {
            left: "5%",
            right: "5%",
            bottom: "35%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: bizDateList,
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}",
            },
          },
          series: seriesList,
        });
      });
    },
    sortTractList(name){
       let tableData = this.trackRecordAllData;
     let sumData = {}; //放置总计一行数据
     tableData.map((item) => {
      console.log(item)
         if (item.ownerName == "合计") {
             sumData = item;
         }
     });
     console.log(sumData)
         tableData = tableData.sort((a, b) => b[name] - a[name]);

         tableData.map((item, index) => {
             if (item.ownerName == "合计") {
                 tableData.splice(index, 1);
             }
             return item;
         });
        //  console.log(tableData)
         tableData.unshift(sumData);
    },
    //
    resetEcharts() {
      setTimeout(() => {
        this.chartRate.resize();
        this.chartAverage.resize();
      }, 200);
    },
    //计算合计
    getTotal(data) {
      data instanceof Array ? (data = data) : (data = []);
      let keys = Object.keys(data[0]);
      let obj = {};

      data.forEach((d) => {
        keys.forEach((e) => {
          if (typeof (d[e] / 1) === "number" && !isNaN(d[e] / 1)) {
            obj[e] = accAdd(obj[e] || 0, d[e]);
          } else {
            obj[e] = "-";
          }
        });
      });
      for (let index = 0; index < keys.length; index++) {
        obj[keys[index]] = formatNumberRgx(obj[keys[index]]);
      }
      return obj;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#reportList {
  // background: #fff;
  .card {
    text-align: left;
    font-size: 0.3rem;
    .title {
      text-align: left;
      padding: 0.5rem 0.2rem 0.3rem;
      font-weight: 600;
      font-size: 0.37rem;
    }
    .filter {
      padding: 0 0.2rem;
      > div {
        display: flex;
        margin-bottom: 0.2rem;
        .t {
          cursor: pointer;
          width: 1.2rem;
          min-width: 45px;
          line-height: 0.5rem;
        }
      }
      .t2 {
        // height: 0.6rem;
        // line-height: 0.6rem;
      }
      .van-field {
        // height: 0.6rem;
        // line-height: 0.6rem;
        // padding: 0;
        // &::after {
        //   border: none;
        // }
      }
    }
    .clicked {
      color: $theme-color;
    }
    .body {
      width: 100%;
      overflow-x: auto;
      table {
        min-width: 100%;
        width: auto;
        text-align: center;
        border-left: 1px solid #ebeef5;
        border-top: 1px solid #ebeef5;
        tr {
          td,
          th {
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
          }
          td {
            background: #fff;
          }
        }
        tr > th:first-child,
        tr > td:first-child {
          position: sticky;
          position: -webkit-sticky;
          left: 0;
          z-index: 10;
          text-align: left;
        }
        thead {
          tr {
            background-color: #f3f9ff;
            th {
              // position: sticky;
              // position: -webkit-sticky;
              // top: 0;
              background-color: #f3f9ff;
            }
          }
        }
        .active {
          background: #e6f2fd;
          td {
            background: #e6f2fd;
          }
        }
      }
    }
    .chart {
      width: 100%;
      height: 15rem;
    }
  }
}
.min1 {
  min-width: 1rem;
}
.min15 {
  min-width: 1.5rem;
}
.min2 {
  min-width: 2rem;
}
.min25 {
  min-width: 2.5rem;
}
.min3 {
  min-width: 3rem;
}
.min4 {
  min-width: 4rem;
}
table tbody tr td,
table thead tr th {
  text-align: center;
  padding-right: 0.1rem;
}
.line {
  border-bottom: 1px solid #ebeef5;
  margin-top: 0.3rem;
}
.space {
  height: 0.5rem;
}
.van-icon{
  display: inline;
}
</style>
